import { render, staticRenderFns } from "./ThirdPartyLinkComplete.vue?vue&type=template&id=66fae4d1&"
import script from "./ThirdPartyLinkComplete.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyLinkComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports